export default __webpack_public_path__ + "static/media/add_credit_card.1be0b54b.svg";